import { from, EMPTY, of } from 'rxjs';
import { catchError, mergeMap, map } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import { TdAjax } from 'app/lib/tdAjax';

import {
  START_TEST,
  PERFORM_CHECK,
  FETCH_MEMBERS,
  performCheck,
  performCheckFulfilled,
  performCheckFailed,
  fetchMembersFulfilled,
  fetchMembersFailed
} from './actions';

const startTestEpic = action$ =>
  action$.pipe(
    ofType(START_TEST),
    // for test case in the payload
    mergeMap(action => from(action.payload)),
    // perform RTE check
    map(testCase => performCheck(testCase),
  ));

const performCheckConcurrency = 10;
const performCheckEpic = (action$, state$) =>
  action$.pipe(
    ofType(PERFORM_CHECK),
    mergeMap(
      action => {
        const canceled = state$.value && state$.value.rteTest && state$.value.rteTest.canceled === true;
        if (canceled) {
          return EMPTY;
        }

        return TdAjax.get('/rte_test/check', action.payload).pipe(
          map(response => performCheckFulfilled({ ...response, index: action.payload.index })),
          catchError(error => of(performCheckFailed(action.payload, error))));
      },
      // only allow this many in-flight at one time
      performCheckConcurrency
    ));

const fetchMembersAction = action$ =>
  action$.pipe(
    ofType(FETCH_MEMBERS),
    mergeMap(action =>
      TdAjax.get('/rte_test/members', action.payload).pipe(
        map(response => fetchMembersFulfilled(response.eligibilityCheck)),
        catchError(error => of(fetchMembersFailed(error))))
  ));

export {
  startTestEpic,
  performCheckEpic,
  fetchMembersAction
};

export default combineEpics(startTestEpic, fetchMembersAction, performCheckEpic);
